(function() {
  const events: Record<string, any> = {};
  window.magicPresetEvents = events;
})();